module.exports = __webpack_public_path__ + "arrow-9f8383a15e0eed33b841182305c811e0.svg";